import { useEffect, useCallback } from 'react';

/**
 * Custom hook to handle ESC key press for modal dismissal
 *
 * @param {boolean} isActive - Whether the listener should be active
 * @param {Function} onEscape - Callback to execute when ESC is pressed
 */
export function useEscapeKey(isActive, onEscape) {
  const handleKeyDown = useCallback((event) => {
    if (event.key === 'Escape') {
      onEscape();
    }
  }, [onEscape]);

  useEffect(() => {
    if (!isActive) return;

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isActive, handleKeyDown]);
}

export default useEscapeKey;
